export const QualificationsData = [
  {
    data: 'Have shipped multiple iOS, Android, and / or web products  ',
    id: 1,
  },
  { data: '5+ years UI/UX experience ', id: 2 },
  {
    data: 'Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles ',
    id: 3,
  },
  {
    data: 'Ability to autonomously pursue elegant solutions to open-ended problems ',
    id: 4,
  },
  { data: 'Comfort with ambiguity ', id: 5 },
  { data: 'Proven ability to create interactive prototypes', id: 6 },
  {
    data: 'Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization',
    id: 7,
  },
  {
    data: 'Strong written communication skills with ability to make transparent design documentation and client-facing presentations',
    id: 8,
  },
  {
    data: 'Ability to create and maintain flow charts, wire frames, prototypes, and mockups.',
    id: 9,
  },
  { data: 'Ability to effect', id: 10 },
  {
    data: 'Experience conducting user research and stakeholder interviews ',
    id: 11,
  },
  {
    data: 'Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc. ',
    id: 12,
  },
  { data: 'Bonus Considerations  ', id: 13 },
];

export const onlyDescription = 'We are looking for a UI/UX Designer to join our team. The world is seeing an explosion in the amount and variety of location-baWe are looking for a versatile UX/UI Designer to join our growing design team. Our designers contribute to clients’ projects at all stages of development. We might start from scratch, conducting user and stakeholder interviews, making personas and journey maps, and continue on to iterating on designs and prototypes through delivering final assets for launch. We might come into the middle of an in-flight program-size project and conduct analysis and usability correction or feature enhancement. We might provide research and vision for handoff to an internal development team.';
